<template>
  <div class="fieldset-display-name-parts">
    <label for="fieldset-display-name">
      <span class="label-text">{{ $tc('formParts.label.displayName') }}</span>
      <span class="required" v-if="required">{{ $tc('formParts.required') }}</span>
    </label>

    <atom-input-text
      v-model="userDisplayName"
      :placeholder="$tc('formParts.placeholder.displayName')"
      id="fieldsetDisplayName"
      :error="showError"
      :isDisabled="isDisabled"
    />

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $tc('formParts.errorMessage.textNumber')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, onMounted } from '@vue/composition-api'
import AtomInputText from '@/components/atoms/input/AtomInputText.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * フィールドセット Display Name入力 バーツ
 */
export default defineComponent({
  name: 'FieldsetDisplayNameParts',
  components: {
    AtomInputText,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * Display Name入力フォームの変更が可能かどうか
     * ブラウザの場合にisDisabled: trueにする
     */
    const isDisabled = ref(!DeviceInfo.isCordova())

    /**
     * userDisplayName
     * @param {string} val
     */
    const userDisplayName = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })

    onMounted(async () => {
      /**
       * ChromeのブラウザだとDisplay Name入力フォームが認証情報と誤認されてしまう。
       * そのため、DOM生成時はdisabled状態とすることでChromeに認識させないようにし、0.5秒後に入力可能な状態にすることで対処している。
       */
      await new Promise((resolve) => {
        setTimeout(resolve, 500)
      })
      isDisabled.value = false
    })

    return {
      userDisplayName,
      isDisabled,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-display-name-parts {
  @include fieldSet();
}
</style>
